
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2069-1760.508a9.111 9.111 0 003.672-.747 9.726 9.726 0 005.078-5.075 9.43 9.43 0 000-7.334 9.731 9.731 0 00-5.093-5.086 9.406 9.406 0 00-7.324 0 9.731 9.731 0 00-5.083 5.083 9.4 9.4 0 00.007 7.337 9.758 9.758 0 005.08 5.075 9.087 9.087 0 003.663.747zm0-1.748a7.577 7.577 0 01-3.008-.6 7.725 7.725 0 01-4.121-4.126 7.916 7.916 0 010-6.025 7.755 7.755 0 014.116-4.136 7.542 7.542 0 013-.6 7.591 7.591 0 013.022.6 7.8 7.8 0 014.131 4.136 7.577 7.577 0 01.6 3.008 7.432 7.432 0 01-.6 3.018 7.873 7.873 0 01-1.66 2.466 7.707 7.707 0 01-2.461 1.66 7.626 7.626 0 01-3.019.599zm-3.077-3.847a.751.751 0 00.566-.234l2.51-2.52 2.52 2.52a.8.8 0 00.576.234.8.8 0 00.791-.791.793.793 0 00-.234-.566l-2.52-2.52 2.525-2.539a.772.772 0 000-1.108.769.769 0 00-.557-.229.815.815 0 00-.566.234l-2.539 2.529-2.525-2.52a.744.744 0 00-.547-.225.784.784 0 00-.571.225.736.736 0 00-.229.547.726.726 0 00.244.557l2.52 2.529-2.52 2.529a.726.726 0 00-.244.557.792.792 0 00.8.791z"}})])])
          )
        }
      }
    